import { Stack, Typography, useTheme } from "@mui/material";
import { Lightbulb } from "lucide-react";
import type { FC } from "react";
import { BalanceLeadAction } from "web_myplann/Finances/Components/BalanceLeadAction";
import { isPositiveFinancialBalance } from "web_myplann/Finances/Helpers/isPositiveFinancialBalance";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { moneyFormatter } from "web_myplann/Shared/Utils/moneyFormatters";

const R = Resources.Dashboard.FinancialBalance;

type Props = {
	income: number;
	expense: number;
	balance: number;
};

export const FinancialBalanceTip: FC<Props> = ({
	income,
	expense,
	balance,
}) => {
	const theme = useTheme();
	const { t } = useResource();
	const positive = isPositiveFinancialBalance(balance);

	return (
		<Stack
			direction="row"
			gap={theme.spacingTokens.sm}
			p={theme.spacingTokens.md}
			bgcolor={theme.palette.blue[50]}
			borderRadius={theme.radii.md}
		>
			<Stack flexShrink={0} mt={theme.spacingTokens.xxs}>
				<Lightbulb
					size={theme.iconSize.sm}
					color={theme.palette.blue[500]}
					aria-hidden
				/>
			</Stack>
			<Stack flex={1} minWidth={0}>
				<Typography
					variant="caption"
					color={theme.palette.grey[700]}
					lineHeight={theme.lineHeight.relaxed}
				>
					{positive
						? t(R.tipPositive, {
								amount: moneyFormatter(
									balance,
									t(Resources.Common.CurrencySign),
								),
							})
						: t(R.tipNegative)}
				</Typography>
				<BalanceLeadAction
					positive={positive}
					income={income}
					expense={expense}
					size="sm"
				/>
			</Stack>
		</Stack>
	);
};
